module.exports = __webpack_public_path__ + "img/quick-shop-carousel.d4039c3e.png";